var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C7.0293 1.5 3 5.5293 3 10.5C3 12.9845 4.00665 15.234 5.63475 16.8626C7.2633 18.492 11.1 20.85 11.325 23.325C11.3587 23.6961 11.6274 24 12 24C12.3726 24 12.6413 23.6961 12.675 23.325C12.9 20.85 16.7367 18.492 18.3652 16.8626C19.9933 15.234 21 12.9845 21 10.5C21 5.5293 16.9707 1.5 12 1.5Z",
    fill: "#FF4433"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6506C13.7397 13.6506 15.1499 12.2403 15.1499 10.5006C15.1499 8.76089 13.7397 7.35059 12 7.35059C10.2603 7.35059 8.84998 8.76089 8.84998 10.5006C8.84998 12.2403 10.2603 13.6506 12 13.6506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYmap);
export default __webpack_public_path__ + "static/media/ymap.c907bb10de9302b1199067dfa8503f26.svg";
export { ForwardRef as ReactComponent };